export default "__VITE_ASSET__53cff01c__"